import { SortDescriptor } from "react-aria-components";

import { ApiKey } from "types/generated";

import { SORT_CONFIG, API_KEYS_SORT_KEYS } from "../constants";

export const sortApiKeys = (items: ApiKey[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const sortColumn = sortDescriptor.column as API_KEYS_SORT_KEYS;
  const key = SORT_CONFIG[sortColumn];

  if (!key) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    const valueA = String(a[key] ?? "");
    const valueB = String(b[key] ?? "");

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
